import React from 'react';
import styled from '@emotion/styled';
import { ArrowLink, H2 } from '../../../../../../ui';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { isAmenity } from '../../../../domain/models/Amenity';
import { IPoi } from '../../../../domain/models/IPoi';
import { AmenityIcon } from '../../../shared/icons/AmenityIcon';
import Responsive from '../../../../../../ui/utils/Responsive';

const StyledItemTitle = styled(H2.withComponent('p'))``;

interface IItemContentProps {
	poi: IPoi;
	titleComponentId: string;
}

export const ItemContent = ({ poi, titleComponentId }: IItemContentProps) => {
	const { t } = useTranslation();
	const amenities = poi.tags.filter(isAmenity);

	return (
		<StyledItemContent>
			<div>
				<StyledItemTitle id={titleComponentId} styling="h4" aria-hidden="true">
					{poi.name}
				</StyledItemTitle>
				<StyledItemArea>{poi.nearbyLandmark}</StyledItemArea>
				{amenities.map((amenity) => (
					<IconWrapper key={amenity}>
						<AmenityIcon amenity={amenity} />
					</IconWrapper>
				))}
			</div>
			{/* Hidden for screen readers since it's repeated content - marked as span: Do not use aria-hidden="true" on focusable elements. */}
			<div aria-hidden>
				<ArrowLink as="span">{t('web_shop_dine_read_more')}</ArrowLink>
			</div>
		</StyledItemContent>
	);
};

export const StyledItemContent = styled.div<{}>`
	display: flex;
	min-height: 100%;
	padding: 24px;
	flex-direction: column;
	justify-content: space-between;
	flex-grow: 1;

	${StyledItemTitle} {
		margin-bottom: 0;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		padding: 6px 12px;
		justify-content: flex-start;
	}
`;

export const StyledItemArea = styled.div<{}>`
	@media (${Responsive.getMediaQueryForBreakpoint('mobile')}) {
		display: none;
	}
`;

export const IconWrapper = styled.span`
	display: inline-block;
	height: 50px;
	width: 40px;
	line-height: 50px;
`;
